export default {

    transform(items, keyword, properties) {
        if (!items) return [];
        if (!keyword) return items;
        return items.filter(item => {
            var itemFound;
            var msgFound;
            var numberFound;
            for (let i = 0; i < properties.length; i++) {
                if (item[properties[i]]) {

                    if (typeof item[properties[i]] == 'object') {
                        for (let msg of item[properties[i]]) {
                            if (msg.texto) {
                                if (msg.texto.toLowerCase().search(keyword.toLowerCase()) !== -1) {
                                    msg.flag = true;
                                    msgFound = true;
                                    msg.key = keyword.toLowerCase();
                                    item['messageSearch'] = msg;
                                    break;
                                }
                            }
                            if (msg.text) {
                                if (msg.text.toLowerCase().search(keyword.toLowerCase()) !== -1) {
                                    msgFound = true;
                                    msg.flag = true;
                                    msg.key = keyword.toLowerCase();
                                    item['messageSearch'] = msg;

                                    break;
                                }
                            }
                        }

                        if (msgFound) break;
                    }
                    if (typeof item[properties[i]] == 'number') {
                        if (item[properties[i]] == keyword) {
                            //console.log('ACHOU PROTOCOLO')
                            numberFound = true;
                            break;
                        }
                    }
                    if (typeof item[properties[i]] == 'string') {
                        if (item[properties[i]].toLowerCase().indexOf(keyword.toLowerCase()) !== -1) {
                            itemFound = true;
                            //              console.log('ACHOU NOME OU EMAIL')

                            break;
                        }
                    }
                }
            }
            if (itemFound || msgFound || numberFound) {
                // console.log('ACHOU');
                return true;
            }
            // return itemFound;
        });

    }
    // if (!term) return value;
    // return (value || []).filter(item => keys.split(',').some(key => item.hasOwnProperty(key) && new RegExp(term, 'gi').test(item[key])));



}
